import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import axiosInstance from "../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import ChartExportMenu from "./ChartExportMenu";
import EditorSwitch from "../editorSwitch";
import { useSelector } from "react-redux";
import { Result } from "antd";

const statusLabels = [
  "Fresh Request",
  "Under Negotiation",
  "Under Execution",
  "Executed",
  "Transaction Closed",
];

const MultiUserRadialBars = ({ color }) => {
  const [rawData, setRawData] = useState({});
  const [dataRawAPI, setDataRawAPI] = useState({});
  const [errorFound, seterrorFound] = useState(null);
  const [visibleCount, setVisibleCount] = useState(3);
  const navigate = useNavigate();
  const [isEditor, setIsEditor] = useState(false); // true = Editor, false = All
  const [isLoading, setIsLoading] = useState(false); // optional
  const [chartRawSeriesState, setChartRawSeriesState] = useState({});
  const comp_id = useSelector((store) => store.auth.userInfo.company_id);
  const compnayId = localStorage.getItem("companyId") || comp_id;

  const statusWiseUser = async () => {
    try {
      setIsLoading(true);
      const res = await axiosInstance.post("/chart/team-agreement-status/", {
        is_editor: isEditor,
        company_id: compnayId,

      });
      if (res.data.message == "No team members to show for this role.") {
        setRawData({});
        seterrorFound("No team members to show for this role.");
        return;
      }
      setDataRawAPI(res.data);
      const transformed = {};
      res.data.data.forEach((entry) => {
        const { user_name, user_id, status_counts } = entry;
        transformed[user_name.toLowerCase()] = {
          user_id,
          fresh_request: status_counts.FRESH_REQUEST || 0,
          under_negotiation: status_counts.UNDER_NEGOTIATION || 0,
          under_execution: status_counts.UNDER_EXECUTION || 0,
          executed: status_counts.EXECUTED || 0,
          transaction_closed: status_counts.TRANSACTION_CLOSED || 0,
        };
      });
      setRawData(transformed);
    } catch (e) {
      seterrorFound(e);
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowMore = () => {
    setVisibleCount((prev) => prev + 9);
  };

  const getCsvFromApiData = (apiData) => {
    if (!apiData?.data) return [];

    return apiData.data.map((entry) => ({
      user_name: entry.user_name,
      FRESH_REQUEST: entry.status_counts.FRESH_REQUEST || 0,
      UNDER_NEGOTIATION: entry.status_counts.UNDER_NEGOTIATION || 0,
      UNDER_EXECUTION: entry.status_counts.UNDER_EXECUTION || 0,
      EXECUTED: entry.status_counts.EXECUTED || 0,
      TRANSACTION_CLOSED: entry.status_counts.TRANSACTION_CLOSED || 0,
    }));
  };
  useEffect(() => {
    statusWiseUser();
  }, [isEditor]);

  useEffect(() => {
    const newSeries = {};
    Object.entries(rawData).forEach(([user, data]) => {
      const rawSeries = statusLabels.map(
        (label) => data[label.toLowerCase().replace(/ /g, "_")] || 0
      );
      newSeries[user] = rawSeries;
    });
    setChartRawSeriesState(newSeries);
  }, [rawData]);


  const allUsers = Object.entries(rawData);
  const visibleUsers = allUsers.slice(0, visibleCount);


  return (
    <div id="user-agreement" className="p-4 dark:bg-[#17153B] border border-gray-200 rounded-lg shadow-sm bg-white">
      <div className="flex justify-between items-center mb-4 ">
        <h2 className="text-lg text-[#303030] font-bold dark:text-white">
          User-wise Agreement Status
        </h2>
        <EditorSwitch initialState={false} state2={'All'} state1={'Editor'} isLoading={isLoading} handleSwitchChange={(checked) => {
          setIsEditor(checked);
        }} />
        <ChartExportMenu chartId="user-agreement" pdfName="UserWise-Agreements" csvData={getCsvFromApiData(dataRawAPI)} />

      </div>
      {errorFound && (
        <div className="flex flex-col items-center justify-center h-40">
        <p className="text-[15px] dark:text-white">Sorry, this user has no team agreements</p>
        </div>
      )}
      <div className="grid grid-cols-3 gap-4">
        {visibleUsers.map(([user, data]) => {
          const rawSeries = chartRawSeriesState[user];
          if (!rawSeries || !rawSeries.length) return null; 

          const maxVal = Math.max(...rawSeries);
          const percentageSeries = rawSeries.map((val) =>
            maxVal > 0 ? (val / maxVal) * 100 : 0
          );

          const chartOptions = {
            chart: {
              type: "radialBar",
              animations: { enabled: true },
              events: {
                dataPointSelection: (event, chartContext, config) => {
                  try {
                    const clickedStatus = statusLabels[config.dataPointIndex];
                    const statusKey = clickedStatus.toUpperCase().replace(/ /g, "_");
                    const userData = rawData[user];
                    if (userData?.user_id) {
                      setTimeout(() => {
                        navigate("/admin/contracts/user-filtered", {
                          state: {
                            user_id: userData.user_id,
                            status: statusKey,
                          },
                        });
                      }, 100);
                    }
                  } catch (error) {
                    console.error("Error in dataPointSelection:", error);
                  }
                },
              },
            },
            plotOptions: {
              radialBar: {
                startAngle: 0,
                endAngle: 270,
                hollow: {
                  margin: 2,
                  size: "20%",
                  background: "transparent",
                },
                track: {
                  show: true,
                  background: "#f2f2f2",
                },
                dataLabels: {
                  name: { show: false },
                  value: { show: false },
                },
                barLabels: {
                  enabled: true,
                  margin: 4,

                  useSeriesColors: true,
                  fontSize: "10px",
                  fontWeight: 600,
                  formatter: (_, opts) => {
                    const realVal = rawSeries[opts.seriesIndex];
                    return `${statusLabels[opts.seriesIndex]}: ${realVal}${" "}`;
                  },
                },
              },
            },
            labels: statusLabels,
            colors: color,
            tooltip: {
              enabled: true,
              y: {
                formatter: (val, { seriesIndex }) => `${rawSeries[seriesIndex]}`,
              },
            },
            legend: { show: false },
          };

          const total = rawSeries.reduce((acc, val) => acc + val, 0) || 0;

          return (
            <div
              key={user}
              className="rounded-xl flex flex-col items-center mr-[-16px] relative"
            >
              <h3 className="text-sm font-semibold mb-1 text-[#464646] capitalize dark:text-gray-300">
                {user}
              </h3>

              <Chart
                key={`${user}-${rawSeries.join("-")}`}
                options={chartOptions}
                series={percentageSeries}
                type="radialBar"
                height={200}
              />

              <div className="absolute top-[54%] left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col justify-center items-center text-center">
                <span className="text-sm text-gray-700 dark:text-white">total</span>
                <div className="text-gray-600 font-bold dark:text-white">
                  {total}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {visibleCount < allUsers.length && (
        <div className="mt-4 text-center ">
          <button
            onClick={handleShowMore}
            className="text-blue-600 hover:underline text-sm font-medium"
          >
            Show More
          </button>
        </div>
      )}

    </div>
  );
};

export default MultiUserRadialBars;
